import { StoreThunk } from "@green24/npm-preact-utils/store";
import { configurationActions } from "../actions/actions";
import { DEFAULT_CONFIGURATION, M_Configuration } from "../../models/Models_Configuration";
import { ObjectUtils, StoreHelpers } from "@green24/npm-javascript-utils";
import { configurationServices } from "../../services/configuration-services";
import { configurationSelector } from "../selectors/selectors";
import { locationThunk } from "../store";

export class Thunk_Configuration extends StoreThunk {
	getConfiguration() {
		this.dispatch(configurationActions.getFetchPending());

		return new Promise((resolve, reject) => {
			configurationServices.getItem().then(data => {
				data = StoreHelpers.deepMerge(M_Configuration, data, true);

				this.dispatch(configurationActions.getFetchFulfilled(data));

				resolve(data);
			}, (res) => {
				this.dispatch(configurationActions.getFetchRejected(res));

				reject(res);
			});
		});
	}

	saveConfiguration(data) {
		this.dispatch(configurationActions.getEditPending());

		let oldConfiguration = configurationSelector.selectData(this.getState());
		let newConfiguration = StoreHelpers.deepMerge(M_Configuration, data, true);

		configurationServices.saveItem(newConfiguration).then(() => {
			this.dispatch(configurationActions.getEditFulfilled(newConfiguration));

			this._handleCleanupAfterChangedConfiguration(newConfiguration, oldConfiguration);
		}, (res) => {
			this.dispatch(configurationActions.getEditRejected(res));
		});
	}

	clearConfiguration() {
		return this.saveConfiguration(DEFAULT_CONFIGURATION);
	}

	_handleCleanupAfterChangedConfiguration(newConfiguration, oldConfiguration) {
		let {changed} = ObjectUtils.diff(newConfiguration, oldConfiguration);

		ObjectUtils.forEach(changed, key => {
			switch (key) {
				case "apiURL":
				case "locationID":
					locationThunk.clearLocation();
					break;
			}
		});
	}
}
